module.exports = __webpack_public_path__ + "static/media/2_step 1.efb3b868.JPG";